module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("James Stories")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#james-stories"
    }
  }, [_vm._v("James Stories")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#preface-prof.-dr-klaus-herbers"
    }
  }, [_vm._v("Preface Prof. Dr Klaus Herbers")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#instead-of-an-introduction"
    }
  }, [_vm._v("Instead of an Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#a-day-like-any-other"
    }
  }, [_vm._v("A Day Like Any Other")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-hour-of-the-horse"
    }
  }, [_vm._v("‘The Hour of the Horse’")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#a-conversation-full-of-dissonance"
    }
  }, [_vm._v("A Conversation Full of Dissonance")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#a-new-beginning"
    }
  }, [_vm._v("A New Beginning")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-i-on-the-twenty-men-whom-the-apostle-delivered-from-the-bondage-of-the-moabites"
    }
  }, [_vm._v("Chapter I On the Twenty Men Whom the Apostle Delivered from the Bondage of the Moabites")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-ii-of-a-man-whose-sin-was-blotted-out-by-divine-arrangement-on-the-holy-altar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II Of a Man Whose Sin Was Blotted Out by Divine Arrangement on the Holy Altar")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-iii-of-the-child-whom-the-apostle-raised-from-the-dead-at-montes-de-oca",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III Of the Child Whom the Apostle Raised from the Dead at Montes De Oca")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-iv-of-the-thirty-lorraineans-and-the-deceased-whom-the-apostle-moved-in-one-night-from-the-ports-of-cize-to-his-monastery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV Of the Thirty Lorraineans and the Deceased, Whom the Apostle Moved in One Night from the Ports of Cize to His Monastery")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-v-of-the-hanged-pilgrim-whom-the-holy-apostle-saved-from-death-though-he-hung-on-the-scaffold-for-thirty-six-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V Of the Hanged Pilgrim, Whom the Holy Apostle Saved from Death, Though He Hung on the Scaffold for Thirty-Six Days")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-vi-of-the-pilgrim-to-whom-the-apostle-gave-as-a-help-an-angel-in-the-form-of-a-donkey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI Of the Pilgrim to Whom the Apostle Gave as a Help an Angel in the Form of a Donkey")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-vii-of-the-sailor-frisono-clothed-with-a-helmet-and-shield-whom-the-apostle-brought-up-from-the-depths-of-the-sea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII Of the Sailor Frisono, Clothed with a Helmet and Shield, Whom the Apostle Brought up from the Depths of the Sea")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-viii-on-the-bishop-who-rescued-from-the-perils-of-the-sea-composed-a-responsory-on-saint-james",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII On the Bishop Who, Rescued from the Perils of the Sea, Composed a Responsory on Saint James")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-ix-of-the-soldier-of-tabaria-to-whom-the-apostle-gave-power-to-defeat-the-turks-and-delivered-him-from-sickness-and-the-perils-of-the-sea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX Of the Soldier of Tabaria, to Whom the Apostle Gave Power to Defeat the Turks, and Delivered Him from Sickness and the Perils of the Sea")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-x-of-the-pilgrim-who-fell-into-the-sea-and-whom-the-apostle-holding-him-by-the-neck-carried-to-the-harbor-for-three-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X Of the Pilgrim Who Fell into the Sea, and Whom the Apostle, Holding Him by the Neck, Carried to the Harbor for Three Days")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-xi-on-bernardo-whom-the-apostle-miraculously-took-out-of-prison",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI On Bernardo, Whom the Apostle Miraculously Took Out of Prison")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-xii-of-the-knight-whom-the-apostle-freed-from-disease-by-the-touch-of-a-shell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XII Of the Knight Whom the Apostle Freed from Disease by the Touch of a Shell")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-xiii-of-the-knight-dalmatius-whom-the-apostle-justified-through-his-pilgrim-raimberto",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XIII Of the Knight Dalmatius, Whom the Apostle Justified Through His Pilgrim Raimberto")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-xiv-of-the-merchant-whom-the-apostle-freed-from-prison",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XIV Of the Merchant Whom the Apostle Freed from Prison")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-xv-of-a-knight-whom-the-holy-apostle-rescued-in-war-when-his-comrades-were-killed-or-imprisoned",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XV Of a Knight Whom the Holy Apostle Rescued in War When His Comrades Were Killed or Imprisoned")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-xvi-of-a-knight-whom-in-the-agony-of-death-oppressed-by-demons-the-holy-apostle-freed-by-means-of-a-beggars-walking-stick-and-a-little-womans-sack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XVI Of a Knight Whom, in the Agony of Death, Oppressed by Demons, the Holy Apostle Freed by Means of a Beggar’s Walking Stick and a Little Woman’s Sack")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-xvii-of-the-pilgrim-who-for-the-love-of-the-apostle-killed-himself-at-the-instigation-of-the-devil-and-james-with-the-help-of-the-holy-mother-of-god-mary-restored-him-from-death-to-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XVII Of the Pilgrim Who, for the Love of the Apostle, Killed Himself at the Instigation of the Devil, and James, with the Help of the Holy Mother of God, Mary, Restored Him from Death to Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-xviii-of-the-count-of-st-giles-to-whom-the-apostle-opened-the-iron-door-of-his-oratory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XVIII Of the Count of St Giles, to Whom the Apostle Opened the Iron Door of His Oratory")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-xix-of-stephen-a-greek-bishop-to-whom-the-holy-apostle-appeared-and-revealed-unknown-future-things",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XIX Of Stephen, a Greek Bishop, to Whom the Holy Apostle Appeared and Revealed Unknown Future Things")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-xx-of-william-a-knight-in-captivity-whom-the-count-struck-with-his-sword-on-his-naked-neck-and-could-not-injure-him",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XX Of William, a Knight in Captivity, Whom the Count Struck with His Sword on His Naked Neck, and Could Not Injure Him")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-xxi-of-a-cripple-to-whom-the-holy-apostle-appeared-in-the-basilica-and-immediately-restored-him-to-health",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XXI Of a Cripple to Whom the Holy Apostle Appeared in the Basilica and Immediately Restored Him to Health")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-xxii-of-a-man-who-was-sold-thirteen-times-and-set-free-thirteen-times-by-the-apostle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XXII Of a Man Who Was Sold Thirteen Times and Set Free Thirteen Times by the Apostle")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#at-james-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At James’ Place")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#epilogue-the-unknown-future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue The Unknown Future")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0